import { z } from 'zod';
import { RMA_RETURN_REASON_MAX_LENGTH } from './rma-return-reason-max-length.js';
const REASON_REQUIRED = 'Enter a reason for the return.';
/** A returned line's required reason (N19, OTC-45); the Create RMA dialog checks it with the same rule. */
export const rmaReturnReasonSchema = z
    .string({ error: REASON_REQUIRED })
    .trim()
    .min(1, REASON_REQUIRED)
    .max(RMA_RETURN_REASON_MAX_LENGTH, `Keep the reason to ${RMA_RETURN_REASON_MAX_LENGTH} characters or fewer.`);
//# sourceMappingURL=rma-return-reason.js.map